import { render, staticRenderFns } from "./EmployeeSettingsPersonal.vue?vue&type=template&id=508a59e4&"
import script from "./EmployeeSettingsPersonal.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettingsPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports